import { render, staticRenderFns } from "./issue-card.vue?vue&type=template&id=60ec5a36&scoped=true&"
import script from "./issue-card.vue?vue&type=script&lang=js&"
export * from "./issue-card.vue?vue&type=script&lang=js&"
import style0 from "./issue-card.vue?vue&type=style&index=0&id=60ec5a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec5a36",
  null
  
)

export default component.exports